import { FC } from 'react';

import { BannerModerationState } from 'utils/banner/utils';
import { BannerModerationStatus } from 'utils/constants/banner';

import { Card } from '@hh.ru/magritte-ui';

import { BannedBySourceList } from 'components/Banners/components/Banner/components/BannerModeration/components/BannedBySourceList';
import { BannedForAllSources } from 'components/Banners/components/Banner/components/BannerModeration/components/BannedForAllSources';

interface BannerModerationProps {
    enabled: boolean;
    bannedAsAdvertisement: boolean;
    bannedForAllSources: boolean;
    singleBanner: boolean;
    states: BannerModerationState[];
}

export const BannerModeration: FC<BannerModerationProps> = ({
    enabled,
    bannedAsAdvertisement,
    bannedForAllSources,
    singleBanner,
    states,
}) => {
    // с бекенда может прийти несколько сабсорсов с одной и той же причиной
    const bannedStates = [
        ...new Map(
            states
                .filter((state) => state.status === BannerModerationStatus.Banned)
                .map((state) => [state.source, state])
        ).values(),
    ];

    if (!enabled || bannedStates.length === 0) {
        return null;
    }

    return (
        <>
            <Card.Between />
            <Card.Segment direction="column" p={24}>
                {bannedForAllSources ? (
                    <BannedForAllSources
                        bannedAsAdvertisement={bannedAsAdvertisement}
                        singleBanner={singleBanner}
                        moderationReason={bannedStates[0].moderationReason}
                    />
                ) : (
                    <BannedBySourceList states={bannedStates} />
                )}
            </Card.Segment>
        </>
    );
};
